import React from "react";

import { Modal, Placeholder } from "rsuite";

const Impressum = ({
  openImpressum,
  handleCloseImpressum,
  backdropImpressum,
}) => {
  return (
    <>
      <Modal
        backdrop={backdropImpressum}
        keyboard={false}
        open={openImpressum}
        onClose={handleCloseImpressum}
        backdropClassName="about-swiper-backdrop"
        size={"full"}
        overflow={false}
        dialogClassName={"imprint-container"}
      >
        <Modal.Header>
          <Modal.Title>Impressum</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          {/* No content, as no future responsibilities are set, yet. */}
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
          <Placeholder.Paragraph />
        </Modal.Body>
      </Modal>
    </>
  );
};

export default Impressum;
